import React from 'react'
import styled from 'styled-components'

const cadIcon = `data:image/svg+xml,${encodeURIComponent(`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
  <g fill="none" fillRule="evenodd">
    <circle cx="16" cy="16" fill="#f70808" r="16" />
    <path
            d="M22.5 19.154c0 2.57-2.086 4.276-5.166 4.533V26h-2.11v-2.336A11.495 11.495 0 019.5 21.35l1.552-2.126c1.383 1.075 2.692 1.776 4.269 2.01v-4.58c-3.541-.888-5.19-2.173-5.19-4.813 0-2.523 2.061-4.252 5.093-4.486V6h2.11v1.402a9.49 9.49 0 014.56 1.776l-1.359 2.196c-1.067-.771-2.158-1.262-3.298-1.495v4.439c3.687.888 5.263 2.313 5.263 4.836zm-7.18-5.327V9.715c-1.527.117-2.327.935-2.327 1.963 0 .98.46 1.612 2.328 2.15zm4.318 5.49c0-1.05-.51-1.681-2.401-2.219v4.23c1.528-.118 2.401-.889 2.401-2.01z"
            fill="#fff"
    />
  </g>
</svg>`)}`

// SVG sprite sheet for special cases
const customSvgs = {
  cad: {
    black: 'https://cdn.jsdelivr.net/npm/cryptocurrency-icons@latest/svg/black/usd.svg',
    color: cadIcon,
    icon: 'https://cdn.jsdelivr.net/npm/cryptocurrency-icons@latest/svg/icon/usd.svg',
    white: 'https://cdn.jsdelivr.net/npm/cryptocurrency-icons@latest/svg/white/usd.svg'
  }
}

const StyledImg = styled.img<{size?: number}>`
  height: auto;
  width: ${(props) => props.size}px;
`

const StyledLoadingDiv = styled.div<{size?: number}>`
  @keyframes wave-square {
    0% {
      background-position: -50% 0;
    }
    100% {
      background-position: 50% 0;
    }
  }
  animation: wave-square 2s infinite ease-out;
  background: linear-gradient(to right, rgba(130, 130, 130, 0.2) 8%, rgba(130, 130, 130, 0.3) 18%, rgba(130, 130, 130, 0.2) 33%);
  background-size: 1000% 100%;
  border-radius: 50%;
  width: ${(props) => props.size}px;
  height: ${(props) => props.size}px;
`

interface CryptoIconProps {
  name: string
  size?: number
  iconStyle?: 'black' | 'color' | 'icon' | 'white'
  isLoading?: boolean
}

export const CryptoIcon: React.FC<CryptoIconProps> = ({isLoading = false, name = 'generic', size = 24, iconStyle = 'color'}) => {
  if (isLoading) {
    return <StyledLoadingDiv size={size} />
  }

  const src = name === 'cad' ? customSvgs[name][iconStyle] : `https://cdn.jsdelivr.net/npm/cryptocurrency-icons@latest/svg/${iconStyle}/${name.toLowerCase()}.svg`

  return (
    <StyledImg
      src={src}
      alt={name}
      size={size}
      onError={(e) => {
        // Fallback to generic icon on error
        e.currentTarget.src = `https://cdn.jsdelivr.net/npm/cryptocurrency-icons@latest/svg/${iconStyle}/generic.svg`
      }}
    />
  )
}
